import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export default function Form({
  id,
  firstName,
  lastName,
  coming,
  meal,
  dietaryRestrictions,
  onChange = () => {},
}) {
  const handleFirstNameChange = (event) => {
    let name = event.target.value;
    if (lastName !== "") {
      name = name + " " + lastName;
    }
    onChange(id, {
      name,
      coming,
      meal,
      dietary_restrictions: dietaryRestrictions,
    });
  };
  const handleLastNameChange = (event) => {
    let name = firstName;
    if (event.target.value !== "") {
      name = name + " " + event.target.value;
    }
    onChange(id, {
      name,
      coming,
      meal,
      dietary_restrictions: dietaryRestrictions,
    });
  };
  const handleComingChange = (event) => {
    let name = firstName;
    if (lastName !== "") {
      name = name + " " + lastName;
    }
    onChange(id, {
      name,
      coming: event.target.value,
      meal,
      dietary_restrictions: dietaryRestrictions,
    });
  };
  const handleMealChange = (event) => {
    let name = firstName;
    if (lastName !== "") {
      name = name + " " + lastName;
    }
    onChange(id, {
      name,
      coming,
      meal: event.target.value,
      dietary_restrictions: dietaryRestrictions,
    });
  };
  const handleDietaryRestrictionChange = (event) => {
    let name = firstName;
    if (lastName !== "") {
      name = name + " " + lastName;
    }
    onChange(id, {
      name,
      coming,
      meal,
      dietary_restrictions: event.target.value,
    });
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "rgb(255, 255, 242)",
          borderRadius: "1rem",
          boxShadow: "0px 0px 15px 5px rgba(0, 0, 0, 0.3)",
          justifyContent: "center",
          alignItems: "center",
          padding: "1rem",
          margin: "1rem",
          marginY: "2rem",
          width: "60%",
          "@media (max-width:600px)": {
            width: "80%",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            marginY: "1rem",
          }}
        >
          <TextField
            label="First name"
            value={firstName}
            onChange={handleFirstNameChange}
            variant="outlined"
            sx={{
              marginX: "0.5rem",
              "& .MuiOutlinedInput-root": {
                color: "rgb(80, 97, 117)", // text color
                "& fieldset": {
                  borderColor: "rgb(80, 97, 117)", // default border
                },
                "&:hover fieldset": {
                  borderColor: "rgb(80, 97, 117)", // hover border
                },
                "&.Mui-focused fieldset": {
                  borderColor: "rgb(80, 97, 117)", // focused border
                },
              },
              "& .MuiInputLabel-root": {
                color: "rgb(80, 97, 117)", // label color
                "&.Mui-focused": {
                  color: "rgb(80, 97, 117)", // focused label color
                },
              },
              "& .MuiFormHelperText-root": {
                color: "rgb(80, 97, 117)", // helper text color
              },
            }}
          />
          <TextField
            label="Last name"
            value={lastName}
            onChange={handleLastNameChange}
            variant="outlined"
            sx={{
              marginX: "0.5rem",
              "& .MuiOutlinedInput-root": {
                color: "rgb(80, 97, 117)", // text color
                "& fieldset": {
                  borderColor: "rgb(80, 97, 117)", // default border
                },
                "&:hover fieldset": {
                  borderColor: "rgb(80, 97, 117)", // hover border
                },
                "&.Mui-focused fieldset": {
                  borderColor: "rgb(80, 97, 117)", // focused border
                },
              },
              "& .MuiInputLabel-root": {
                color: "rgb(80, 97, 117)", // label color
                "&.Mui-focused": {
                  color: "rgb(80, 97, 117)", // focused label color
                },
              },
              "& .MuiFormHelperText-root": {
                color: "rgb(80, 97, 117)", // helper text color
              },
            }}
          />
        </Box>
        <FormControl
          sx={{
            alignItems: "center",
            marginY: "1rem",
            "& .MuiFormLabel-root.Mui-focused": {
              color: "rgb(80, 97, 117)",
            },
            "& .MuiRadio-root.Mui-checked": {
              color: "rgb(80, 97, 117)",
            },
          }}
        >
          <FormLabel id="coming-radio-buttons">
            Will you be attending?
          </FormLabel>
          <RadioGroup
            row
            name="coming-radio-buttons-group"
            value={coming}
            onChange={handleComingChange}
          >
            <FormControlLabel
              value="coming"
              control={<Radio />}
              label="Will attend"
            />
            <FormControlLabel
              value="notcoming"
              control={<Radio />}
              label="Unable to attend"
            />
          </RadioGroup>
        </FormControl>
        <FormControl
          sx={{
            alignItems: "center",
            marginY: "1rem",
            "& .MuiFormLabel-root.Mui-focused": {
              color: "rgb(80, 97, 117)",
            },
            "& .MuiRadio-root.Mui-checked": {
              color: "rgb(80, 97, 117)",
            },
          }}
        >
          <FormLabel id="meal-radio-buttons">Choose your main course</FormLabel>
          <RadioGroup
            row
            name="meal-radio-buttons-group"
            value={meal}
            onChange={handleMealChange}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <FormControlLabel
                value="turkey"
                control={<Radio />}
                label="Traditional Turkey Dinner with pave potatoes topped with caviar"
              />
              <FormControlLabel
                value="surf+turf"
                control={<Radio />}
                label="Grilled Beef Fillet and Jumbo Shrimp with pave potatoes topped with caviar"
              />
              <FormControlLabel
                value="vegetarian"
                control={<Radio />}
                label="Portobello Mushroom Wellington (Vegetarian)"
              />
            </Box>
          </RadioGroup>
        </FormControl>
        <TextField
          label="Dietary Restrictions"
          value={dietaryRestrictions}
          onChange={handleDietaryRestrictionChange}
          multiline
          maxRows={4}
          variant="standard"
          sx={{
            width: "60%",
            "& .MuiInputLabel-root": {
              color: "rgb(80, 97, 117)", // label color
              "&.Mui-focused": {
                color: "rgb(80, 97, 117)", // focused label color
              },
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "rgb(80, 97, 117)",
            },
          }}
        />
      </Box>
    </Box>
  );
}
